import { render, staticRenderFns } from "./AllowedDates.vue?vue&type=template&id=c20e9d68&"
import script from "./AllowedDates.vue?vue&type=script&lang=js&"
export * from "./AllowedDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports